import type { BrandContext } from '@/lib/brand/types';

type SelfServiceBrand = Pick<
  BrandContext,
  'brandKey' | 'isApprovedHost' | 'partnerId' | 'partnerKey'
>;

export const isStandaloneExploreBrand = (brand: SelfServiceBrand) =>
  brand.isApprovedHost &&
  brand.brandKey === 'explore' &&
  !brand.partnerId &&
  !brand.partnerKey;

const isNylaKeyedSelfServiceBrand = (brand: SelfServiceBrand) =>
  brand.isApprovedHost &&
  brand.brandKey === 'nyla' &&
  Boolean(brand.partnerId || brand.partnerKey);

export const isSelfServiceSignupEnabled = (brand: SelfServiceBrand) =>
  isStandaloneExploreBrand(brand) || isNylaKeyedSelfServiceBrand(brand);

export const isSelfServiceSubscriptionEnabled = (brand: SelfServiceBrand) =>
  isStandaloneExploreBrand(brand) || isNylaKeyedSelfServiceBrand(brand);

export const canUseSelfServiceSubscription = (role?: string | null) =>
  role === 'TEACHER' || role === 'ADMIN';
